import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch, onMounted, onBeforeMount, ref, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import Topbar from "@/app/workspace/controls/TopbarControl.vue";
import { useAppContext } from '@/app/_tech';
import { Guid } from '@/lib';
import XbqProcessor from '@/ops/workspaces_spec/XbqProcessor';

import { UI } from '@/context';
import sys from '@/sys';

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkspaceView',
  setup(__props) {

const route = useRoute()
const context = useAppContext();

const workspace_name = route.params.workspace;

const topbar = ref<InstanceType<typeof Topbar> | null>(null)

function onKeyUp(args: KeyboardEvent): void {

  //sys.info(args.code)

  if (args.ctrlKey && args.code == 'Slash') topbar.value?.focus()
}

function setup() {

  try {

    if (typeof workspace_name === "string") {

      let wid: Guid | null = null;

      if (context.cursor.workspace === null && context.storages.workspace != null) //#someday Check whehter the storage intself in 100% correct no-error state
      {
        return; //we have to wait such as this means request for getting workspace was made alread
      }

      if (workspace_name === '') {

        //pick the first workspace
        wid = context.model.defaultWorkspaceWid()!;
      }
      else {

        wid = context.model.workspaceWid(workspace_name);
      }


      if (wid != null) {

        if (context.cursor.workspace === null || context.cursor.workspace.Wid() != wid) {

          context.storages.workspace = context.service.workspaceStorage(wid); //and wait unti it comes at controlel from SignalR
          context.ops.xbq = new XbqProcessor(context.storages.workspace!)
        }
      }
      else context.error(`[THERE-IS-NO-WORKSPACE:${workspace_name}]`) //#literal
    }

  } catch (error) {

    sys.exception(error)
  }
}

watch(() => workspace_name, setup);

onMounted(setup);

onBeforeMount(() => {

  //setup console access

  const uiController = new UI();

  uiController.consoleContent = function () {

    var x = topbar.value;

    if (x != null) {

      return x.console()
    }

    sys.warn("/workspace - Console (Topbar) controller is not set up")

    return '';
  }

  uiController.consoleContentClear = () => {

    var x = topbar.value;

    if (x != null) {

      return x.consoleClear()
    }

    sys.warn("/workspace - Console (Topbar) controller is not set up")
  }

  context.ui = uiController

});

// function onTicketModalClose() {

//   context.api.resetAuxTicketContextIf();

// }

function command(value: string) {

  context.triggers.command(value)
}

onMounted(() => {
  document.addEventListener('keyup', onKeyUp);
})

onBeforeUnmount(() => {
  document.removeEventListener('keyup', onKeyUp)
})

// methods: {
//   onKeyUp(event) {
//     if (event.key == 't' && event.ctrlKey) this.translate();
//   },
//   translate() {
//     // Call Google Translation API.
//   }
//}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", { onKeydown: onKeyUp }, [
    _createVNode(Topbar, {
      class: "w-top",
      onCommand: command,
      ref_key: "topbar",
      ref: topbar
    }, null, 512),
    _createVNode(_component_router_view, { class: "w-main" })
  ], 32))
}
}

})